const PROFILE_CACHE_KEY = "ams_profile_cache_v1";
const NOTIFICATIONS_CACHE_KEY = "ams_notifications_cache_v1";

const readCache = (key, ttlMs) => {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.ts !== "number") return null;
    if (Date.now() - parsed.ts > ttlMs) {
      sessionStorage.removeItem(key);
      return null;
    }
    return parsed.data;
  } catch (e) {
    return null;
  }
};

const writeCache = (key, data) => {
  try {
    sessionStorage.setItem(
      key,
      JSON.stringify({
        ts: Date.now(),
        data,
      })
    );
  } catch (e) {
    // ignore quota / private mode errors
  }
};

const clearCache = (key) => {
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    // ignore
  }
};

export const profileCache = {
  key: PROFILE_CACHE_KEY,
  ttlMs: 5 * 60 * 1000,
  get: () => readCache(PROFILE_CACHE_KEY, 5 * 60 * 1000),
  set: (data) => writeCache(PROFILE_CACHE_KEY, data),
  clear: () => clearCache(PROFILE_CACHE_KEY),
};

export const notificationsCache = {
  key: NOTIFICATIONS_CACHE_KEY,
  ttlMs: 2 * 60 * 1000,
  get: () => readCache(NOTIFICATIONS_CACHE_KEY, 2 * 60 * 1000),
  set: (data) => writeCache(NOTIFICATIONS_CACHE_KEY, data),
  clear: () => clearCache(NOTIFICATIONS_CACHE_KEY),
};
